<template>
  <div>
    <AppHeader />
    <div id="container">

      <!-- Banner -->
      <BannerSlider />

      <!-- Home Intro -->
      <div class="home_bg">
        <div class="home_txt">
          <h3>Wholesalers, franchises, restaurants, hotels, coffee shops, pubs, bars
            <span class="sub">around the globe in need of eco-friendly disposable paper goods make up our target market.</span>
          </h3>
          <p>Our main goals are to protect the environment and lower plastic waste by spreading biodegradable disposable items for the food service industry and changing consumer behavior.</p>
        </div>
      </div>

      <!-- Products -->
      <div class="mainpro_bg">
        <div class="mainpro">
          <div class="webtitle">PaperStirrer <span>Eco-friendly</span> Products</div>
          <ul>
            <li v-for="category in categories" :key="category.id">
              <ol>
                <li class="category_img">
                  <router-link :to="'/products/' + category.id">
                    <img v-if="category.image" :src="getImageSrc(category.image)" :alt="category.name">
                    <svg v-else width="280" height="220" viewBox="0 0 280 220" fill="none">
                      <rect width="280" height="220" rx="8" fill="#f0f7ec"/>
                      <text x="140" y="100" text-anchor="middle" font-size="60">{{ getProductEmoji(category.name) }}</text>
                      <text x="140" y="150" text-anchor="middle" font-size="14" fill="#46b200" font-family="Montserrat">{{ category.name }}</text>
                    </svg>
                  </router-link>
                </li>
                <li class="category_con">
                  <router-link :to="'/products/' + category.id">{{ category.name }}</router-link>
                  <span>{{ category.description }}</span>
                </li>
              </ol>
            </li>
          </ul>
        </div>
      </div>

      <!-- Compostable / Biodegradable -->
      <div class="application_bg" :style="{ backgroundImage: 'url(' + require('@/assets/images/Home/Compostable.png') + ')' }">
      </div>
      <hr class="section-hr">

      <!-- Stats -->
      <div class="stats_bg">
        <div class="stats">
          <div class="stat-item fade-in" v-for="stat in stats" :key="stat.label">
            <h3>{{ stat.value }}</h3>
            <p>{{ stat.label }}</p>
          </div>
        </div>
      </div>

      <!-- About / Company -->
      <div class="homeabout_bg">
        <div class="homeabout">
          <div class="about_txt">
            <div class="webtitle"><a href="#">Company</a></div>
            <p>PaperStirrer is an experienced manufacturer of eco-friendly disposable paper products, based in DongGuan, China. Our products include paper straws, paper knives, paper forks, paper spoons, paper sporks, paper coffee stirrers, paper cutlery sets and paper food containers, which are 100% biodegradable and certified to be U.S. FDA and EU food safe compliant.</p>
            <div style="text-align:center;margin-top:1.5rem">
              <a href="#" class="btn_more" style="background:var(--green);color:#fff">More</a>
            </div>
          </div>
          <div class="about_img">
            <div class="video-poster" @click="showVideoModal = true">
              <img :src="require('@/assets/images/Home/company.jpg')" alt="PaperStirrer Factory">
              <div class="play-btn"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Certificates -->
      <div class="cer_box">
        <div class="cer_inner">
          <div class="cer_subtitle">International Recognized</div>
          <div class="webtitle">Our <span>Certificates</span></div>
          <p class="cer_desc">We maintain the highest quality standards, certified by globally recognized organizations.</p>
          <ul>
            <li class="fade-in" v-for="(cert, idx) in certList" :key="idx" @click="openCertModal(cert)">
              <div class="cer_card">
                <div class="cer_img">
                  <img :src="cert.src" :alt="cert.name">
                </div>
                <div class="cer_label">{{ cert.name }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Lightbox Modal -->
      <transition name="cer-fade">
        <div class="cer_modal" v-if="certModal" @click.self="certModal = null">
          <button class="cer_modal_close" @click="certModal = null">&times;</button>
          <div class="cer_modal_img">
            <img :src="certModal.src" :alt="certModal.name">
          </div>
          <div class="cer_modal_name">{{ certModal.name }}</div>
        </div>
      </transition>

      <!-- Video Modal -->
      <transition name="cer-fade">
        <div class="cer_modal" v-if="showVideoModal" @click.self="closeVideoModal">
          <button class="cer_modal_close" @click="closeVideoModal">&times;</button>
          <div class="cer_modal_video">
            <video ref="companyVideo" :src="require('@/assets/video/company.mp4')" controls autoplay />
          </div>
        </div>
      </transition>

      <!-- Quality / Videos -->
      <div class="application_bg1">
        <div class="application1">
          <div class="webtitle">Proven <span>Quality</span></div>
          <ul>
            <li class="fade-in" v-for="(video, index) in videos" :key="video.id">
              <div class="video_img" @click="playHomeVideo(video)">
                <img v-if="video.thumbnail" :src="getImageSrc(video.thumbnail)" :alt="video.title">
                <svg v-else width="100%" viewBox="0 0 500 280" fill="none">
                  <rect width="500" height="280" rx="15" fill="#1a3a1a"/>
                  <rect x="0" y="0" width="500" height="280" rx="15" :fill="`url(#grad${index})`" opacity=".6"/>
                  <defs><linearGradient :id="`grad${index}`" x1="0" y1="0" x2="500" y2="280"><stop offset="0%" stop-color="#2d5a2d"/><stop offset="100%" stop-color="#1a3a1a"/></linearGradient></defs>
                  <text x="250" y="150" text-anchor="middle" font-size="50">🎬</text>
                </svg>
                <div class="play-btn"></div>
              </div>
              <span>{{ video.title }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- Video Modal -->
      <transition name="cer-fade">
        <div class="cer_modal" v-if="showVideoModal" @click.self="closeHomeVideoModal">
          <button class="cer_modal_close" @click="closeHomeVideoModal">&times;</button>
          <div class="cer_modal_video">
            <video ref="homeVideo" :src="currentVideoUrl" controls autoplay />
          </div>
        </div>
      </transition>

    </div>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import BannerSlider from '@/components/BannerSlider.vue'
import { getCategories } from '@/api/category'
import { getHomeVideos, incrementViews } from '@/api/video'

export default {
  name: 'Home',
  components: { AppHeader, AppFooter, BannerSlider },
  data() {
    return {
      categories: [],
      stats: [
        { value: '50+', label: 'Countries Served' },
        { value: '200+', label: 'Product SKUs' },
        { value: '10M+', label: 'Monthly Output' },
        { value: '15+', label: 'Years Experience' }
      ],
      certModal: null,
      showVideoModal: false,
      currentVideoUrl: '',
      certList: [
        { name: 'ISO 9001', src: require('@/assets/images/Home/Certificates1.png') },
        { name: 'BRCGS', src: require('@/assets/images/Home/Certificates2.png') },
        { name: 'SMETA', src: require('@/assets/images/Home/Certificates3.png') },
        { name: 'FSC', src: require('@/assets/images/Home/Certificates4.png') }
      ],
      videos: []
    }
  },
  mounted() {
    this.loadCategories()
    this.loadHomeVideos()
    this.initScrollAnimation()
  },
  methods: {
    async loadCategories() {
      const res = await getCategories()
      const data = res.data || res
      this.categories = Array.isArray(data) ? data : []
    },
    async loadHomeVideos() {
      try {
        const res = await getHomeVideos()
        this.videos = Array.isArray(res) ? res : (res.data || [])
        // Re-init scroll animation after videos load
        this.$nextTick(() => {
          this.initScrollAnimation()
        })
      } catch (e) {
        console.error('Failed to load home videos:', e)
        this.videos = []
      }
    },
    getImageSrc(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      return process.env.VUE_APP_BASE_API.replace('/api', '') + path
    },
    openCertModal(cert) {
      this.certModal = cert
    },
    closeVideoModal() {
      this.showVideoModal = false
      if (this.$refs.companyVideo) {
        this.$refs.companyVideo.pause()
      }
    },
    async playHomeVideo(video) {
      this.currentVideoUrl = this.getImageSrc(video.video_url)
      this.showVideoModal = true
      // Increment views
      try {
        await incrementViews(video.id)
        // Update local views count
        const index = this.videos.findIndex(v => v.id === video.id)
        if (index !== -1) {
          this.videos[index].views = (this.videos[index].views || 0) + 1
        }
      } catch (e) {
        console.error('Failed to increment views:', e)
      }
    },
    closeHomeVideoModal() {
      this.showVideoModal = false
      this.currentVideoUrl = ''
      if (this.$refs.homeVideo) {
        this.$refs.homeVideo.pause()
      }
    },
    getProductEmoji(name) {
      const n = (name || '').toLowerCase()
      if (n.includes('cutlery')) return '🍴'
      if (n.includes('straw')) return '🥤'
      if (n.includes('container')) return '🥡'
      if (n.includes('cup')) return '☕'
      return '🍴'
    },
    initScrollAnimation() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible')
            observer.unobserve(e.target)
          }
        })
      }, { threshold: 0.15 })
      this.$nextTick(() => {
        document.querySelectorAll('.fade-in:not(.visible)').forEach(el => observer.observe(el))
      })
    }
  }
}
</script>
